<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultBackHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Multiple Results ({{ locations.length }})</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content color="light">
  <div class="tw:m-4 tw:text-xs">
    <ion-note color="medium">
      Multiple property profiles resulted for your search. Please select one to retrieve.
    </ion-note>
  </div>
  <ion-list [inset]="true" lines="full" class="no-last-line">
    @for (location of locations; track location) {
    <ion-item [button]="true" (click)="loadProfile(location)">
      <ion-label>
        <ion-text class="tw:font-bold">{{ location | redAddress: addressType.LineOne }}</ion-text><br />
        <ion-text color="medium">{{ location | redAddress: addressType.LineTwo }}</ion-text>
      </ion-label>
    </ion-item>
    }
  </ion-list>
</ion-content>
